import { trigger, transition, state, style, animate, keyframes } from '@angular/animations';

export const AVATAR_ANIMATIONS = [
    trigger('animateAvatar', [
        transition('* => true', animate('250ms', keyframes([
            style({
                transformStyle: 'preserve-3d',
                transform: 'scaleX(1.3) scaleY(1.3) scaleZ(1)',
                offset: 0.5
            }),
            style({
                transformStyle: 'preserve-3d',
                transform: 'scaleX(1) scaleY(1) scaleZ(1)',
                offset: 1
            })
        ])))
    ])
];
